<template>
    <div class="d-flex flex-row w-100 p-2">
        <div class="col d-flex justify-content-center align-content-center position-relative">
            <draggable class="m-auto" v-model="expression" v-bind="{animation: 500}">
                <transition-group class="d-flex flex-wrap">
                    <div v-for="(item,index) of expression" :key="index">
                        <b-badge :variant="item.isError ? 'danger' : type_variant[item.type]"
                                 class="badge-text ml-1 mt-1 cursor-pointer"
                                 @dblclick="removeExEl(index)">
                            {{ item.label }}
                        </b-badge>
                    </div>
                </transition-group>
            </draggable>
            <div v-if="selectedConstant!=null" class="position-absolute top right mt-1 mr-1">
                <b-form-input class="mt-1 ml-1"
                              type="number" autofocus
                              @blur="finishConstantInput(selectedConstant)"
                              @update="changeConstant(selectedConstant, $event)">
                </b-form-input>
            </div>
        </div>
        <div class="ml-auto card-cover">
            <b-button-group class="d-flex flex-column">
                <b-button v-for="(item,index) of variables" :key="index"
                          variant="light"
                          @click="addVariableToExpression(item)">
                    {{ item.label }}
                </b-button>
            </b-button-group>
        </div>
        <template v-for="(list,i) of rightSideList">
            <div class="d-flex flex-column ml-1" :key="i">
                <template v-for="(item,index) of list">
                    <b-button pill :key="index"
                              class="mt-1 cursor-pointer"
                              @click="addOperatorToExpression(item)"
                              variant="light">
                        {{ item }}
                    </b-button>
                </template>
            </div>
        </template>
        <div class="d-flex align-content-center ml-1">
            <b-button variant="light"
                      class="m-auto h-100"
                      @click="addConstant">
                <i class="fa-solid fa-terminal"></i>
            </b-button>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import ExpressionMixins from "@/components/echarts-part/TableChart/mixins/ExpressionMixins";

const OPERATOR = {
    ADD: '+',
    SUBTRACT: '-',
    MULTIPLY: '*',
    DIVIDE: '/'
}
const BRACKETS = {
    BRACKETS_START: '(',
    BRACKETS_END: ')'
}
const EL_TYPE = {
    VARIABLE: 0,
    OPERATOR: 1,
    CONSTANT: 2
}
export default {
    name: "ExpressionGenerator",
    components: {draggable},
    mixins: [ExpressionMixins],
    props: {
        variables: {
            /*[{
            *   label: '',
            *   key: ''
            * }]*/
            type: Array,
            default: () => []
        },
        expressionStr: {
            type: String,
            default: ''
        }
    },
    computed: {
        rightSideList() {
            let tempList = [];
            tempList.push(OPERATOR);
            tempList.push(BRACKETS);
            return tempList;
        },
    },
    data() {
        return {
            /*[{
            *   type: EL_TYPE,
            *   label: '',
            *   value: '',
            *   isError: false
            * }]*/
            expression: [],
            operate_list: OPERATOR,
            bracket_list: BRACKETS,
            type_variant: {
                0: 'warning',
                1: 'light',
                2: 'success',
            },
            selectedConstant: null,
        }
    },
    watch: {
        expression() {
            this.checkValidity();
        },
    },
    mounted() {
        this.initExpression(this.expressionStr);
    },
    methods: {
        addVariableToExpression(item) {
            this.expression.push({
                type: EL_TYPE.VARIABLE,
                label: item.label,
                value: item.key
            })
        },
        addOperatorToExpression(item) {
            this.expression.push({
                type: EL_TYPE.OPERATOR,
                label: item,
                value: item
            })
        },
        addConstantToExpression(val) {
            this.expression.push({
                type: EL_TYPE.CONSTANT,
                label: val,
                value: val
            })
        },
        addConstant() {
            let temp = {
                type: EL_TYPE.CONSTANT,
                label: 0,
                value: null
            };
            this.selectedConstant = temp;
            this.expression.push(temp);
        },
        finishConstantInput() {
            this.selectedConstant = null;
        },
        changeConstant(item, event) {
            item.value = event;
            item.label = item.value;
        },
        removeExEl(index) {
            this.expression.splice(index, 1);
        },
        //检查表达式是否合法
        checkValidity() {
            let bracketStartStack = [];
            for (let item of this.expression) {
                let isError = false;
                if (item.type === EL_TYPE.OPERATOR) {
                    if (item.value === BRACKETS.BRACKETS_START) {
                        bracketStartStack.push(item);
                    } else if (item.value === BRACKETS.BRACKETS_END) {
                        //no bracket start
                        if (bracketStartStack.length <= 0) {
                            isError = true;
                        } else {
                            bracketStartStack.pop();
                        }
                    }
                }
                item.isError = isError;
            }
            //no bracket end
            if (bracketStartStack.length > 0) {
                for (let item of bracketStartStack) {
                    item.isError = true;
                }
            }
        },
        //Get the expression string
        getExpressStr() {
            let str = '';
            for (let item of this.expression) {
                if (item.type !== undefined) {
                    if (item.type === EL_TYPE.VARIABLE) {
                        str += '${' + item.value + '}';
                    } else {
                        str += item.value;
                    }
                }
            }
            let f = this.checkExpression(str);
            return f ? str : null;
        },
        initExpression(str) {
            this.expression = [];
            if (str) {
                let temp = null;
                let type;
                for (let i = 0; i < str.length; i++) {
                    let char = str.charAt(i);
                    if (char === '$') {
                        if (temp != null && type === EL_TYPE.CONSTANT) {
                            this.addConstantToExpression(temp);
                            temp = null;
                        }
                        type = EL_TYPE.VARIABLE;
                    } else if (char === '{' && type === EL_TYPE.VARIABLE) {
                        let end = str.indexOf('}', i);
                        let variableName = str.substring(i + 1, end);
                        let has = false;
                        for (let item of this.variables) {
                            if (item.key === variableName) {
                                this.addVariableToExpression(item);
                                has = true;
                                break;
                            }
                        }
                        if (!has) {
                            this.addVariableToExpression({
                                label: variableName,
                                key: variableName
                            })
                        }
                        i = end;
                        type = null;
                    } else if ((char >= '0' && char <= '9') || char === '.') {
                        type = EL_TYPE.CONSTANT;
                        if (temp == null) {
                            temp = '';
                        }
                        temp += char;
                    } else {
                        for (let row of this.rightSideList) {
                            for (let item in row) {
                                if (row[item] === char) {
                                    if (temp != null && type === EL_TYPE.CONSTANT) {
                                        this.addConstantToExpression(temp);
                                        temp = null;
                                        type = null;
                                    }
                                    this.addOperatorToExpression(row[item]);
                                    break;
                                }
                            }
                        }
                    }
                }
                if (temp != null && type === EL_TYPE.CONSTANT) {
                    this.addConstantToExpression(temp);
                }
            }
        },
    }
}
</script>

<style scoped>
.badge-text {
    font-size: .8rem;
    padding: .5rem;
}

.card-cover {
    overflow: auto;
}

.card-cover::-webkit-scrollbar {
    display: none; /* Chrome Safari */
}
</style>
